module.exports = __webpack_public_path__ + "static/media/job_property_type.edf83079.svg";